import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { getColores, deleteColor } from "../helpers/rutaColores";
import ModalColor from "./ModalColor";
import "../css/tableclientes.css";

const TableColor = () => {
  const [colores, setColores] = useState({
    data: { colores: [] },
    loading: true,
    error: "",
  });

  const [colorSeleccionado, setColorSeleccionado] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaTodo();
  }, []);

  const consultaTodo = async () => {
    try {
      const datosColores = await getColores();

      setColores({
        data: datosColores || { colores: [] },
        loading: false,
        error: "",
      });
    } catch (e) {
      console.error("❌ Error al cargar colores:", e);

      setColores((s) => ({
        ...s,
        loading: false,
        error: e?.message || "Error al cargar colores",
      }));
    }
  };

  const handleClose = () => {
    setShow(false);
    consultaTodo();
  };

  const handleShow = () => setShow(true);

  const modificaColor = (color) => {
    setColorSeleccionado(color);
    handleShow();
  };

  const eliminarColor = (id) => {
    if (window.confirm("¿Está seguro que desea borrar el color?")) {
      deleteColor(id).then(() => consultaTodo());
    }
  };

  if (colores.loading) {
    return <div className="p-3">Cargando colores…</div>;
  }

  if (colores.error) {
    return <div className="p-3 text-danger">{colores.error}</div>;
  }

  const rows = (colores.data?.colores || [])
    .filter((c) => c?.activo ?? true)
    .sort((a, b) => {
      const A = (a?.nombre || "").toString().trim();
      const B = (b?.nombre || "").toString().trim();

      if (!A && !B) return 0;
      if (!A) return 1;
      if (!B) return -1;

      return A.localeCompare(B, "es", { sensitivity: "base" });
    });

  return (
    <div className="table-container">
      <div className="col-12 mt-4"></div>

      <Table striped bordered hover>
        <thead>
          <tr className="header">
            <th className="borrar">Acciones</th>
            <th>Código</th>
            <th>Color</th>
          </tr>
        </thead>

        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={3} className="text-center">
                No hay colores.
              </td>
            </tr>
          ) : (
            rows.map((color) => (
              <tr key={color._id}>
                <td className="borrar" style={{ whiteSpace: "nowrap" }}>
                  <div className="d-flex align-items-center justify-content-center gap-2 flex-nowrap">
                    <button
                      className="btn btn-primary"
                      onClick={() => modificaColor(color)}
                    >
                      <i className="fa fa-pencil-square-o" />
                    </button>

                    <button
                      className="btn btn-danger"
                      onClick={() => eliminarColor(color._id)}
                    >
                      <i className="fa fa-trash-o" />
                    </button>
                  </div>
                </td>

                <td>{color.codigoHex || "-"}</td>
                <td>{color.nombre || "-"}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      <ModalColor
        show={show}
        handleClose={handleClose}
        color={colorSeleccionado}
      />
    </div>
  );
};

export default TableColor;